import axios from 'axios';
import toast from 'react-hot-toast';

function getVendorKey() {
  try {
    const vendor = JSON.parse(localStorage.getItem('ecommerce_vendor') || '{}');
    return vendor?.api_key || '';
  } catch (_) {
    return '';
  }
}

function normalizeV1Error(err) {
  const data = err.response?.data;
  const message = data?.error?.message || data?.error || data?.message || 'Request failed';
  const code = data?.error?.code || data?.code || 'UNKNOWN';
  const normalized = new Error(message);
  normalized.code = code;
  normalized.status = err.response?.status || 0;
  return normalized;
}

function normalizeLegacyError(err) {
  const data = err.response?.data;
  const message = data?.error || data?.message || 'Request failed';
  const code = data?.code || 'UNKNOWN';
  const normalized = new Error(message);
  normalized.code = code;
  normalized.status = err.response?.status || 0;
  return normalized;
}

// ─── Legacy /api/ecommerce client (raw envelope) ───
export const legacyApi = axios.create({ baseURL: '/api/ecommerce' });

legacyApi.interceptors.request.use((config) => {
  const key = getVendorKey();
  if (key) config.headers['x-vendor-api-key'] = key;
  return config;
});

legacyApi.interceptors.response.use(
  (res) => ({ data: res.data }),
  (err) => Promise.reject(normalizeLegacyError(err))
);

// ─── Versioned /api/v1/ecommerce client (standard envelope { success, data }) ───
export const v1Api = axios.create({ baseURL: '/api/v1/ecommerce' });

v1Api.interceptors.request.use((config) => {
  const key = getVendorKey();
  if (key) config.headers['x-vendor-api-key'] = key;
  return config;
});

v1Api.interceptors.response.use(
  (res) => ({ data: res.data?.data ?? res.data }),
  (err) => Promise.reject(normalizeV1Error(err))
);

// Centralized error toast helper
export function handleApiError(err, fallback = 'Request failed') {
  const msg = err?.message || fallback;
  const code = err?.code;
  if (code === 'REQUEST_IN_PROGRESS') {
    toast.error('This request is already being processed. Please wait a moment.');
  } else if (code === 'IDEMPOTENCY_KEY_REUSED') {
    toast.error('This action was already submitted. Please wait or use a fresh Idempotency-Key.');
  } else if (code === 'CLIENT_NOT_CONFIGURED') {
    toast.error('Client integration is not configured. Please contact the administrator.');
  } else if (code === 'CLIENT_API_TIMEOUT') {
    toast.error('The client system did not respond in time. Please retry later.');
  } else {
    toast.error(msg);
  }
}
